import AxiosInstance from '../index';

interface signInResult {
  accessToken: string;
  checkSum: string;
}

export default class API_Sign_In_Service extends AxiosInstance {
  async signIn(id: string, pwd: string): Promise<signInResult> {
    try {
      const url = 'login';
      const { data } = await this.API.post(url, { email: id, pwd });
      if (!data.success) {
        throw new Error();
      }

      return { accessToken: data.data.accessToken, checkSum: data.data.checkSum };
    } catch (err) {
      if (err.response) {
        alert(err.response.data.message);
      } else if (err.message) {
        alert(err.message);
      }
    }
  }

  async getZero() {
    try {
      const url = 'balance/zero';
      const { data } = await this.API.get(url);
      if (!data.success) {
        throw new Error();
      }
      const { BNB, BAGO, BAGOX } = data.data

      return { BNB, BAGO, BAGOX };
    } catch (err) {
      if (err.response) {
        alert(err.response.data.message);
      } else if (err.message) {
        alert(err.message);
      }
    }
  }
}
